import React from "react";
import { useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { FILTER_OPTIONS } from "../constants";

export const Clubready = ({
  control,
  membershipMetric,
  isEditMode,
  agreementNamesWithZeroSales
}) => {
  const { membershipCalculationAgreementTypes } = useSelector(
    (state) => state.organizations.commonSettings
  );

  return (
    <div className="clubready-tab">
      <div className="admin-organizations__section">
        <div className="switch">
          <p className="switch__title">Send daily report emails</p>
          <Controller
            control={control}
            name="send_daily_report_emails"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="send_daily_report_emails"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>

        <div className="switch">
          <p className="switch__title">Include cross regional visits (recalculation required)</p>
          <Controller
            control={control}
            name="include_cross_regional_visits"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="zeroReinclude_cross_regional_visitstention"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>
      </div>

      <div className="admin-organizations__section">
        <div className="switch">
          <p className="switch__title">Start from appointment by default</p>
          <Controller
            control={control}
            name="start_from_appointment_by_default"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="start_from_appointment_by_default"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>

        <div className="switch">
          <p className="switch__title">Exclude preconverted clients from appointments</p>
          <Controller
            control={control}
            name="exclude_preconverted_clients_from_appointments"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="exclude_preconverted_clients_from_appointments"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>
      </div>

      <div className="admin-organizations__section">
        <div className="admin-organizations__dropdown">
          <p>Daily email notifier class</p>
          <Controller
            control={control}
            name="daily_email_notifier_class"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  valueKey="name"
                  height={275}
                  haveOnSelectChange
                  options={FILTER_OPTIONS.dailyEmailNotifier}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>
        <div className="admin-organizations__dropdown">
          <p>Dashboard attrition logic</p>
          <Controller
            control={control}
            name="attrition_rate_logic"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  options={FILTER_OPTIONS.attritionRateLogic}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__dropdown">
          <p>Daily pulse attrition logic</p>
          <Controller
            control={control}
            name="daily_pulse_attrition_rate_logic"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  options={FILTER_OPTIONS.attritionRateLogic}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>
      </div>

      <div className="admin-organizations__section">
        <div className="admin-organizations__dropdown">
          <p>Membership agreement/club type</p>
          <Controller
            control={control}
            name="membership_calculation_agreement_types"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  valueKey="name"
                  height={275}
                  haveOnSelectChange
                  enableOnly
                  options={membershipCalculationAgreementTypes}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__dropdown">
          <p>Membership logic</p>
          <Controller
            control={control}
            name="membership_metric"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  options={FILTER_OPTIONS.membershipMetrics}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>
      </div>

      <div className="admin-organizations__section">
        {isEditMode &&
          (membershipMetric.id === "NumberOfPayingMembersByPricingOption" ||
            membershipMetric.id === "NumberOfPayingMembersByPricingOptionExcludingZeroSales") && (
            <div className="admin-organizations__dropdown">
              <p>Agreement names with zero sales</p>
              <Controller
                control={control}
                name="agreement_names_with_zero_sales"
                render={({ field: { onChange, value } }) => {
                  return (
                    <Dropdown
                      height={275}
                      haveOnSelectChange
                      includeSelectAll
                      enableOnly
                      options={agreementNamesWithZeroSales}
                      selectedFilters={value ?? []}
                      numberDisplayed={0}
                      onSelectChange={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
          )}

        {membershipMetric.id !== "NumberOfMembersByProfile" ? (
          <div className="admin-organizations__dropdown">
            <p>Agreement start</p>
            <Controller
              control={control}
              name="membership_start"
              render={({ field: { onChange, value } }) => {
                return (
                  <Dropdown
                    height={275}
                    haveOnSelectChange
                    options={FILTER_OPTIONS.membershipStart}
                    selectedFilters={value ?? []}
                    numberDisplayed={0}
                    onSelectChange={(data) => onChange(data)}
                  />
                );
              }}
            />
          </div>
        ) : null}

        {membershipMetric.id === "NumberOfMembersByProfile" ||
        membershipMetric.id === "NumberOfMembersByStatus" ? (
          <div className="switch">
            <p className="switch__title">Exclude frozen members from total members count</p>
            <Controller
              control={control}
              name="exclude_frozen_members_from_total_members_count"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="exclude_frozen_members_from_total_members_count"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
